<template>
  <div class="cc-container">
    <div class="cc-wrapper" :class="{ 'color-bg': headerColor }" @click="selectCard">
      <img :src="cardType" />
      <div class="cc-wrap-info">
        <p>0000 - 0000 - 0000 - {{ card.last4 }}</p>
      </div>
      <i class="el-icon-caret-bottom" v-if="selected && !hideCaret" />
    </div>
    <transition name="cc">
      <div class="credit-card" v-loading="removing" v-if="selected" :style="{ backgroundImage: cardBg }">
        <img :src="cardTypeWhite" alt="" />
        <div class="card-number">
          <span v-for="i in 3" :key="i">0000</span>
          <span>{{ card.last4 }}</span>
        </div>
        <div class="card-info">
          <p>{{ $auth.user.name }}</p>
          <p>{{ card.expirationMonth }}/{{ card.expirationYear }}</p>
        </div>
      </div>
    </transition>
    <el-button type="text" v-if="selected && editable" icon="el-icon-close" @click="removeCard">Remove</el-button>
  </div>
</template>

<script>
import VisaImg from '@/assets/card-types/visa.svg'
import MasterCardImg from '@/assets/card-types/mastercard.svg'
import VisaImgWhite from '@/assets/visa-pay-logo.svg'
import MasterCardImgWhite from '@/assets/master-card-logo.svg'
import CardBg from '@/assets/credit-card-bg.svg'
import CardBgGold from '@/assets/credit-card-bg-gold.svg'

export default {
  name: 'CreditCard',
  props: {
    hideCaret: Boolean,
    headerColor: String,
    editable: {
      type: Boolean,
      required: false
    },
    card: {
      type: Object,
      required: true
    },
    selectedId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      removing: false
    }
  },
  computed: {
    selected () {
      return this.card.id === this.selectedId
    },
    cardBg () {
      return 'url(' + CardBg + ')'
    },
    cardTypeWhite () {
      switch (this.card.brand.toLowerCase()) {
        case 'visa':
          return VisaImgWhite
        case 'mastercard':
          return MasterCardImgWhite
        default:
          return ''
      }
    },
    cardType () {
      switch (this.card.brand.toLowerCase()) {
        case 'visa':
          return VisaImg
        case 'mastercard':
          return MasterCardImg
        default:
          return ''
      }
    }
  },
  methods: {
    removeCard () {
      this.removing = true
      this.$emit('remove', this.card)
    },
    selectCard () {
      this.$emit('select', this.card.id)
    }
  }
}
</script>

<style lang="scss" scoped>

  .cc-container {
    margin-bottom: 10px;
  }

  .cc-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 50px;
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.025);
    font-size: 13px;

    &.color-bg {
      border-top: 1px solid $bg;
      border-left: 1px solid $bg;
      border-right: 1px solid $bg;

    }

    i {
      margin-left: auto;
      color: $main;
    }

    img {
      height: 30px;
      width: auto;
      margin-right: 20px;
    }

    .cc-wrap-info {
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        line-height: 20px;
        margin: 0;
      }
    }
  }

  @keyframes cc-down {
    0% {
      opacity: 0;
      height: 0px;
    }

    100% {
      opacity: 1;
      height: 160px;
    }
  }

  @keyframes cc-up {
    0% {
      opacity: 1;
      height: 160px;
    }

    100% {
      opacity: 0;
      height: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/CreditCard.vue